import { init as initEvent, trigger as triggerEvent } from './events';
import { mergeCommonParams, setEventParams, setFieldNameMap } from './params';
import { receiveReport, setReady } from './report';
import { loadScript, parseCookie } from './util';
const beaconLibUrl = 'https://isee.weishi.qq.com/delivory/2.1.14/beacon_web.min.js';

const setParams = (eventTags) => {
  if (eventTags) {
    setEventParams(eventTags, {
      dupcatedWarn: true,
      overwrite: true,
      syncWriteOnce: true,
    });
  }
};

let readyCount = 0;

const readyChange = () => {
  setReady();
  readyCount = readyCount + 1;
  if (+readyCount === 2) {
    triggerEvent('onReady');
  }
};

const sdkInit = ({ appKey, openId, channelId }) => {
  if (window.BeaconAction) {
    readyChange();
  } else {
    console.log('start load beacon lib:', appKey);
    loadScript(beaconLibUrl).then(() => {
      if (window.BeaconAction) {
        window.wsBeaconIns = new window.BeaconAction({
          appkey: appKey, // 系统或项目id,必填
          versionCode: '3.3.1', // 版本,选填
          openid: openId, // 用户uin，rtx 或 qq 号,选填
          channelID: channelId, // 渠道号,选填
          strictMode: false, // 严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
          delay: 3000, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
          debug: false, // 是否上报到测试环境(开启实时联调),选填
        });
        console.log('beacon lib loaded');
        readyChange();
      } else {
        console.log('BeaconAction.init load error');
      }
    });
  }
};

/**
 * 需要传入平台参数
 * @param {Object} params
 */
export const init = function (config) {
  console.log('init start...');
  const { paramCollecter, appKey, JSBNS, fieldNameMap, eventTags, expose } = config;
  let { pageID, params, openId, channelId } = config;
  const cookie = parseCookie(document.cookie);
  openId = openId || cookie.openid || cookie.person_id;
  channelId = channelId || '';

  if (!appKey) {
    console.error('appKey not found');
    return;
  }

  if (!pageID) {
    pageID = params && params.pageID;
  }

  if (!pageID) {
    console.error('pageID not found.');
    return;
  }

  params = { ...(params || {}), pageID };

  initEvent(config);

  sdkInit({ appKey, openId, channelId });

  if (fieldNameMap) {
    setFieldNameMap(fieldNameMap);
  }

  setParams(eventTags);

  console.log('start collect platform params...');
  paramCollecter(JSBNS, (platformParams) => {
    console.log('paramCollecter platformParams collected.');
    mergeCommonParams(platformParams, params || {});
    // 初始化支持页面曝光上报
    if (expose) {
      report(expose.tag, expose.params);
    }

    readyCount = readyCount + 1;
    if (+readyCount === 2) {
      triggerEvent('onReady');
    }
  });
};

export const report = function (tag, params) {
  receiveReport(tag, params);
};
